// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakpoint":"767","tabletBreakpoint":"1024","dialog":"styles_dialog__3wqYa"};